export default "__VITE_ASSET__CEljcycj__"